<template>
	<div
		class="group cursor-pointer relative p-4 sm:p-6 lg:p-8 border border-gray-200/60 rounded-xl sm:rounded-2xl bg-white shadow-sm hover:shadow-xl hover:border-primary/20 hover:-translate-y-1 transition-all duration-300 overflow-hidden"
	>
		<!-- Decorative corner accent -->
		<div
			class="absolute top-0 right-0 w-16 sm:w-20 lg:w-24 h-16 sm:h-20 lg:h-24 bg-primary/5 rounded-bl-2xl sm:rounded-bl-3xl opacity-0 group-hover:opacity-100 transition-all duration-500 transform group-hover:scale-110"
		></div>
		
		<!-- Top accent line -->
		<div class="absolute top-0 left-0 right-0 h-1 bg-primary opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

		<div class="relative space-y-3 sm:space-y-4">
			<!-- Header with message and status -->
			<div class="flex flex-col sm:flex-row sm:items-start gap-3 sm:gap-4">
				<div class="flex-1 min-w-0">
					<p class="text-xs sm:text-sm font-medium text-gray-500 mb-1">
						Subject
					</p>
					<p
						class="text-base sm:text-lg font-semibold text-gray-900 leading-relaxed truncate"
					>
						{{ appointment.title }}
					</p>
				</div>
				<span
					:class="[
						'inline-flex items-center px-2 sm:px-3 py-1 sm:py-1.5 rounded-full text-xs font-bold uppercase tracking-wider shadow-md border transition-all duration-200 flex-shrink-0',
						{
							'bg-green-500 text-white border-green-200 shadow-green-100':
								appointment.status === 'ACCEPTED',
							'bg-accent text-white border-accent shadow-accent/50 hover:bg-accent/90':
								appointment.status === 'PENDING',
							'bg-red-500 text-white border-red-200 shadow-red-100':
								appointment.status === 'Cancelled',
						},
					]"
				>
					{{ appointment.status }}
				</span>
			</div>

			<!-- Divider -->
			<div class="relative">
				<div class="absolute inset-0 flex items-center">
					<div class="w-full border-t border-gray-200/60"></div>
				</div>
				<div class="relative flex justify-center">
					<div class="w-8 h-px bg-gray-300"></div>
				</div>
			</div>

			<!-- Date section -->
			<div class="flex items-center gap-3">
				<div
					class="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 bg-primary rounded-lg sm:rounded-xl flex items-center justify-center shadow-lg border border-primary/20 transition-all duration-300 group-hover:scale-105 sm:group-hover:scale-110 group-hover:shadow-xl"
				>
					<svg
						class="w-4 h-4 sm:w-5 sm:h-5 text-white"
						fill="none"
						stroke="currentColor"
						viewBox="0 0 24 24"
					>
						<path
							stroke-linecap="round"
							stroke-linejoin="round"
							stroke-width="2"
							d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
						/>
					</svg>
				</div>
				<div>
					<p
						class="text-xs font-bold text-gray-500 uppercase tracking-wider mb-1"
					>
						Appointment Date
					</p>
					<p class="text-sm font-bold text-gray-900 group-hover:text-primary transition-colors duration-200">
						{{ formatDate(appointment.appointmentDate) }}
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'AppointmentItem',
	props: {
		appointment: {
			type: Object,
			required: true,
		},
	},
	methods: {
		formatDate(date) {
			// Format date to a more readable format
			return new Date(date).toLocaleDateString('en-US', {
				weekday: 'long',
				year: 'numeric',
				month: 'long',
				day: 'numeric',
			});
		},
	},
};
</script>
